import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ShadowDomWrapper extends UcoastEl {
    static htmlSelector = 'shadow-dom-wrapper'
    private observer: MutationObserver | null = null
    targetElement: string
    colorSchemeClass: string
    customClass: string
    styleContainer: HTMLElement
    constructor() {
        super()
        this.targetElement = q.ra(this, 'data-uc-target-shadow-element')
        this.colorSchemeClass = q.ra(this, 'data-uc-shadow-dom-wrapper-color-scheme-class')
        this.styleContainer = q.rs('[data-uc-shadow-dom-wrapper-style]', this)
        this.customClass = q.ra(this, 'data-uc-shadow-dom-wrapper-unique-class')
    }

    override connectedCallback() {
        super.connectedCallback()
        this.initializeObserver()
    }

    override disconnectedCallback() {
        super.disconnectedCallback()
        this.disconnectObserver()
    }

    private initializeObserver() {
        const config = { childList: true, subtree: true }
        const callback = (mutationsList: MutationRecord[], observer: MutationObserver) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Check if the third-party custom element has been loaded
                    const customElement = this.querySelector(this.targetElement)
                    if (customElement) {
                        // Create and insert the style tag into the Shadow DOM
                        const customElementShadow = customElement.shadowRoot
                        if (customElementShadow) {
                            const rootDiv = customElementShadow.querySelector('[data-form-root="true"]')
                            if (rootDiv) {
                                rootDiv.classList.add('app-shopify-form')
                                rootDiv.classList.add(this.colorSchemeClass)
                                rootDiv.classList.add(this.customClass)
                            }
                            customElementShadow.appendChild(this.styleContainer)
                        }

                        // form phone number will cause a jump on mobile
                        // hide the form until the section is visible
                        // TODO: formalize the solution
                        if (customElementShadow?.querySelector('input#phone_number')) {
                          // hide it until scrolled and shown
                          customElementShadow?.querySelector('form')?.style.setProperty('display', 'none');
                          const intersectionObserver = new IntersectionObserver((entries) => {
                            // Loop through the entries
                            entries.forEach(entry => {
                              if (entry.isIntersecting) {
                                // The target element is now visible in the viewport
                                customElementShadow?.querySelector('form')?.style.setProperty('display', 'block');

                                // Stop observing once it's visible (optional)
                                intersectionObserver.unobserve(entry.target);
                              }
                            });
                          });
                          intersectionObserver.observe(customElement);
                        }

                        // Stop observing once we've found the custom element and styled it
                        observer.disconnect()
                        this.observer = null
                        document
                            .querySelectorAll('shadow-dom-wrapper')
                            ?.forEach((el) => el.classList.add('active'))
                        break
                    }
                }
            }
        }

        this.observer = new MutationObserver(callback)

        // Start observing the target node for configured mutations
        this.observer.observe(this, config)
    }

    private disconnectObserver() {
        // Stop observing when this element is disconnected from the DOM
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
    }
}
